module.exports = __webpack_public_path__ + "img/saibamais.dd48780d.jpg";